import AxiosInterceptor from "api/interceptor";

const property = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    return property.get("/properties", { params: qstr });
  },
  find(id) {
    return property.get("/properties/" + id);
  },
  create(inputs) {
    return property.post("/properties", inputs);
  },
  update(id, inputs) {
    return property.put("/properties/" + id, inputs);
  },
  delete(id) {
    return property.delete("/properties/" + id);
  }
};
